import { ErrorBaseData } from '.'

export const appointmentErrors: Record<string, ErrorBaseData> = {
  AppointmentNotFoundException: {
    message: 'Agendamento não encontrado',
    description: 'Não foi possível encontrar o agendamento. Verifique as informações e tente novamente',
  },
  AppointmentScheduleNotAvailableException: {
    message: 'Horário não disponível',
    description: 'Não foi possível marcar o agendamento, pois já existe um outro atendimento para este horário',
  },
}
